module.exports = new __parcel__URL__("conkers-pocket-tales.6ab35446.jpg").toString();